export default __webpack_public_path__ + "static/media/zebra.0be9a358.jpg";